import { render, staticRenderFns } from "./Translator.vue?vue&type=template&id=37de2e4a"
import script from "./Translator.vue?vue&type=script&lang=js"
export * from "./Translator.vue?vue&type=script&lang=js"
import style0 from "./Translator.vue?vue&type=style&index=0&id=37de2e4a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports